<template>
  <dashboard-management
    :application-id="applications.Provider"
    :change-post-status="api.changePostStatus"
    :get-all-posts="api.getAllPosts"
    :get-applications="api.getApplications"
    :get-document="api.getDocument"
    :get-guides="api.getGuides"
    :get-links="api.getLinks"
    :get-modules="api.getModules"
    :get-types="api.getTypes"
    :get-videos="api.getVideos"
    :mark-messages="api.markMessages"
    :update-participant-workshop-status="api.updateParticipantWorkshopStatus"
  />
</template>
<script>
import DashboardManagement from '@quisit/dashboard-management';
import {
  getTypes,
  getAllPosts,
  cardsbymodule as getLinks,
  changePostStatus,
  updateParticipantWorkshopStatus,
  getVideos,
  getGuides,
  getApplications,
  getModules,
  getDocument,
} from '@/modules/dashboard/dashboardPostMipeApi.js';
import dashbordApi from '@/modules/dashboard/mipeApi';
import APPLICATION_IDS from '@/utils/constants/applications';

export default {
  name: 'DashboardMaintenance',
  components: { DashboardManagement },
  computed: {
    api() {
      return Object.freeze({
        getTypes,
        getAllPosts,
        getApplications,
        getModules,
        getLinks,
        changePostStatus,
        updateParticipantWorkshopStatus,
        markMessages: dashbordApi.markMessages,
        getGuides: getGuides,
        getVideos: getVideos,
        getDocument: getDocument,
      });
    },
    applications() {
      return { ...APPLICATION_IDS };
    },
  },
};
</script>
<style scoped></style>
